<div class="modal">
    <div class="modal-content">
        <div class="headerModal">
            <h3>{{ ('cloud.menu.delete.' + (isComm ? 'comm' : 'file') + '.title') | translate }}</h3>
            <div class="flex-grow-1"></div>
            <span class="close pointer" style="padding-left: 2em;" (click)="doClose()">
                <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i>
            </span>
        </div>
        <div>
            <div>
                <p>{{ ('cloud.menu.delete.' + (isComm ? 'comm' : 'file') + '.line1') | translate }}</p>
                <p>{{ ('cloud.menu.delete.' + (isComm ? 'comm' : 'file') + '.line2') | translate }}</p>
                <p>{{ ('cloud.menu.delete.' + (isComm ? 'comm' : 'file') + '.line3') | translate }}</p>
                <p><strong>{{ ('cloud.menu.delete.' + (isComm ? 'comm' : 'file') + '.line4') | translate }}</strong></p>
            </div>
            <div class="center">
                <button class="btn btn-secondary" (click)="doClose()" [disabled]="formsDisabled">{{'common.cancel'|translate}}</button>
                <button class="btn btn-secondary" (click)="doDelete()" [disabled]="formsDisabled">{{'common.delete'|translate}}</button>
            </div>
            <div class="center">
                <span [style.color]="formsShowGlobalError ? 'red' : null">{{formsShowGlobalError ? ('cloud.errors.cantDelete' | translate) : '\u00A0'}}</span>
            </div>
            <mat-progress-bar [mode]="(deleteProgress && !formsShowGlobalError) ? 'indeterminate' : 'determinate'" [value]="formsShowGlobalError ? 100 : 0" style="position: absolute; bottom: 0; left: 0; width: 100%" [color]="formsShowGlobalError ? 'warn' : null"></mat-progress-bar>
        </div>
    </div>
</div>
